import React from 'react';

import { Button, Group, Stack, Text } from '@mantine/core';
import useDeleteTaxRate from 'hooks/taxRate/useDeleteTaxRate';
import { TaxRate } from 'types';
import notificationHandler from 'utils/notifications';

const DeleteTaxRateModal = ({
  taxRate,
  handleClose,
}: {
  taxRate: TaxRate;
  handleClose: () => void;
}): JSX.Element => {
  const deleteMutation = useDeleteTaxRate();

  const handleDelete = (): void => {
    const { successNotification, errorNotification } = notificationHandler();
    deleteMutation.mutate(taxRate.taxRateId, {
      onSuccess: () => {
        successNotification('Tax Rate delete success', `${taxRate.name} successfully deleted.`);
        handleClose();
      },
      onError: error => {
        errorNotification('Tax Rate delete failed', error.response?.data?.message);
      },
    });
  };

  return (
    <Stack>
      <Text>{`Are you sure you want to delete ${taxRate.name}?`}</Text>
      <Text color='dimmed'>This action cannot be undone.</Text>
      <Group position='right'>
        <Button onClick={handleDelete} color='red' loading={deleteMutation.isLoading}>
          Delete
        </Button>
      </Group>
    </Stack>
  );
};

export default DeleteTaxRateModal;
